export const APPLY_TYPE = {
    FAST: 'FAST',
    FULL: 'FULL'
};

export const APPLICATION_STATUS = {
    CREDIT_DECLINE_HARD: 'creditDeclineHard',
    CREDIT_IN_ELIGIBLE: 'creditIneligible',
    INVALID_EMAIL_LENGTH_DECLINED: 'INVALID_EMAIL_LENGTH_DECLINED',
    PENDING_ACCOUNT_CREATION: 'pendingAccountCreation',
    PENDING_MANUAL_REMEDIATION: 'pendingManualRemediation',
    LINKED_TO_DIFF_USER: 'linkedToDiffMember',
    STOP_SOFT_DECLINED: 'STOP_SOFT_DECLINED',
    SYSTEM_ERROR: 'systemError'
};

export const APPLICATION_RESPONSE = {
    APPROVED: 'approved'
};

export const TERMS_URL = 'https://www.paypal.com/ppclander';
export const TERMS_POPUP_WIDTH = 385; // see: https://github.paypal.com/Checkout/xo-ui-components/blob/bd54e5b0565804123e849157a0fefdf16c0d9dc3/src/popup/directive.js#L45

export const TERMS_RESOURCES_TO_PREFETCH = [
    { href: 'https://www.paypalobjects.com/digitalassets/c/paypal-ui/fonts/PayPalSansSmall-Regular.woff2', as: 'font' },
    { href: 'https://www.paypalobjects.com/digitalassets/c/paypal-ui/fonts/PayPalSansBig-Light.woff2', as: 'font' }
];

export const BUSINESS_CASE_VARIATION = {
    HERMES: {
        FIRST_BUTTON: 'HERMES',
        SECOND_BUTTON: 'SECOND_BUTTON'
    }
};

export const US_NO_INTEREST_OFFER = {
    INTERVAL: 'months',
    TERM: 6,
    THRESHOLD: 99
};

export const US_MILITARY_STATES = {
    AA: 'AA',
    AE: 'AE',
    AP: 'AP'
};
